import ProfileOverview from '~/components/common/user-profile/ProfileOverview';

const UserProfile = () => {
  return <ProfileOverview />;
};

export default UserProfile;
